const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_HOME_DATA':
      return { ...state, ...action.data };

    case 'FAIL_HOME_DATA':
      return { ...state, ...action.data };

    default:
      return state;
  }
};
